import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Collection } from "../components";
import {
  getCauseCollection,
  fetchCodeDetails,
  getSettings,
} from "../../../shared/utilities/actions";
import {
  Settings,
  DefaultSettings,
  CodeDetails,
  DefaultCodeDetails,
  Cause,
  CauseCollection,
} from "../../../shared/types";

export interface MainProps {
  causeId: string | null;
}

export const Main = ({ causeId }: MainProps): React.JSX.Element => {
  const [busy, setBusy] = useState<boolean>(true);
  const [settings, setSettings] = useState<Settings>({ ...DefaultSettings });
  const [codeDetails, setCodeDetails] = useState<CodeDetails>({
    ...DefaultCodeDetails,
  });
  const [cause, setCause] = useState<Cause>();

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let themeId = fetchCodeDetails(codeDetails.themeId, setCodeDetails);
      let settingsResponse: Settings = await getSettings(themeId);
      setSettings(settingsResponse);
      let causeCollectionResponse: CauseCollection = await getCauseCollection(
        settingsResponse.causeCollectionId
      );
      if (
        causeCollectionResponse?.causes &&
        causeCollectionResponse.causes.length > 0
      ) {
        let cause = causeCollectionResponse.causes.find((item) => {
          return item.id == causeId;
        });
        setCause(cause);
      }
      setBusy(false);
    };
    fetchData();
  }, []);

  return (
    <Collection
      busy={busy}
      eins={cause ? cause.eins : []}
      handleSelect={(ein: string) => {
        setBusy(true);
        window.location.href = `/charity/?charityId=${ein}&causeId=${causeId}`;
      }}
    />
  );
};
